import { render, staticRenderFns } from "./ContactoView.vue?vue&type=template&id=951ff560&scoped=true&"
import script from "./ContactoView.vue?vue&type=script&lang=js&"
export * from "./ContactoView.vue?vue&type=script&lang=js&"
import style0 from "./ContactoView.vue?vue&type=style&index=0&id=951ff560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ff560",
  null
  
)

export default component.exports